import { Container } from "@mui/material";

import "./styles.scss";
import StatsComponent from "../../Components/Stats";
const Overview: React.FC = () => {
  return (
    <Container>
      <div className="overview-container">
        <StatsComponent />
      </div>
    </Container>
  );
};

export default Overview;
